import React, {useEffect, useState} from 'react'
import FailedModal from "../../CustomModal/Failed";
import Loader from "../../../Loader/Loader";
import Header from "../../layout/header";
import SuccessModal from "../../CustomModal/Success";
import {toast} from "react-toastify";
import DashboardMenu from "../../layout/dashboardMenu";
import useLatLng from "../../../hooks/uselatlng/uselatlng";

const AttendanceRequestApproval = ({
                               moduleType,
                               activityId,
                               history,
                               attendanceRequest,
                               makeAttendanceRequest=[],
                               match
                           }) => {

    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [inputList, setInputList] = useState([{
        remark:'',
        long:'',
        lat:''
    }])
    const [successMessage, setSuccessMessage] = useState('')
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const [isAllow, setIsAllow] = useState(false);

    const handleInput = (key, val) => {
        let list = [...inputList]
        list[0][key] = val
        setInputList(list)
    }
    const handleSubmit = async (e, status) => {
        e.preventDefault()
        let list = [...inputList]
        list[0]['lat'] = islatlng?.lat
        list[0]['long'] = islatlng?.lng
        list[0]['id'] = match?.params?.id
        list[0]['status'] = status

        if(list[0]['remark'] === ''){
            toast.error("Please give your remark.")
            return false
        }

        setIsLoading(true)
        await attendanceRequest(list[0])
        setIsLoading(false)
    }

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (makeAttendanceRequest?.status === 200) {
            setIsSuccessModalOpen(true)
            setSuccessMessage(makeAttendanceRequest?.message)
        } else if (makeAttendanceRequest?.status !== undefined && makeAttendanceRequest?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setSuccessMessage(makeAttendanceRequest?.message)
        }
    }, [makeAttendanceRequest])

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={successMessage}
                url={`attendance-regularization-request`}
            />

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={successMessage}
                countToOpenModal={countToOpenModal}
            />
            <DashboardMenu/>
            <Loader isLoading={isLoading}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <Header
                        title={'Attendance Regularisation'}
                        history={history}
                    />
                    <div className="container-fluid">
                        {/*Heading*/}
                        <div className="container-fluid bootstrap snippets bg-white">
                            <div className="row">
                                <div className="col-md-12">
                                    <div
                                        className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                        {/*<h1 className="h3 mb-0 text-black-100">*/}
                                        {/*    <span style={{color: "green"}}>{distance}</span>*/}
                                        {/*</h1>*/}
                                    </div>
                                    <div className="card-body bg-white">
                                        <div className="user">
                                            <div className="form-group row">
                                                <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Remark"
                                                                onChange={(e) => {
                                                                    handleInput('remark', e.target.value)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                required={true}
                                                            />
                                                    <label className="large-label float-lb">
                                                        {/*Description*/}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*</div>*/}
                                    <div className="col-md-12 mt-4 d-flex">
                                        <button className="btn btn-primary btn-user mr-4 submit-btn"
                                                onClick={(e) => handleSubmit(e, 2)}
                                        >
                                            Approval
                                        </button>
                                        <button className="btn btn-primary btn-user submit-btn bg-red"
                                                onClick={(e) => handleSubmit(e, 3)}
                                        >
                                            Reject
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default AttendanceRequestApproval